export const SIGN_IN_BTN_CLICKED = "SIGN_IN_BTN_CLICKED"

export const FB_PIXEL_ALLOWED_COURSES = process.env?.REACT_APP_FB_PIXEL_ALLOWED_COURSES || ''
